import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, Form } from 'react-final-form'
import { injectIntl } from 'react-intl'
import {
  MenuItem,
  Button,
  Grid,
  Icon,
  InputAdornment,
  IconButton,
  CircularProgress,
  FormControlLabel,
  FormControl,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from '@material-ui/core'
import moment from 'moment'
import FileIcon from '@material-ui/icons/Description'
import messages from 'routes/App/Apps/Logbook/translate'
import TextArea from 'components/common/Form/TextArea'
import SelectInput from 'components/common/Form/SelectInput'
import getValidator, {
  VALIDATOR_IS_EMPTY,
  VALIDATOR_IS_NUMBER_OR_FLOAT,
} from 'validation'
import TimePickerInput from 'components/common/Form/TimePicker'
import {
  fetchSingleFilledEventData,
  saveDailyEntry,
  fetchEventList,
  fetchSingleEventData,
  setSingleEventLoader,
  saveBatchInputs,
} from 'reducers/logbook/reducer'
import { uploadFiles, removeFiles } from 'reducers/common/files/reducer'
import { showNotice } from 'reducers/notice'
import NoticeHelper from 'helpers/notice'
import {
  getFileObject,
  TYPE_CONSTANT_VALUE,
  TYPE_INPUT_BOOLEAN,
  TYPE_INPUT_FILE,
  TYPE_INPUT_NUMBER,
  TYPE_INPUT_TEXTAREA,
  TYPE_LIST,
  TYPE_MULTIPLE,
} from 'helpers/logbook'
import Input from 'components/common/Form/Input'
import withPromise from 'helpers/withPromise'
import { LOGBOOK_DAILY } from 'constants/requestTypes'
import { Checkbox } from 'components/common/FormInputs'
import FinalFormMultipleSelect from 'components/common/Form/FinalFormMultipleSelect'
import StatusIcon, {
  STATUS_TYPE_BASE,
  STATUS_TYPE_COMPLETE,
} from './StatusIcon'

class MultiLocusQuestionForm extends Component {
  constructor(props) {
    super(props)
    const [{ evt_logbook_id, locus }] = props.event.values
    this.state = {
      cage: locus ? locus.id : 0,
      eventId: evt_logbook_id,
      valueIndex: 0,
      isFileLoading: false,
      ...this.fetchForm(props),
    }
    this.fetchEventData(this.props, this.state.eventId)
  }

  shouldComponentUpdate(nextProps) {
    const { eventData, eventFilledData } = this.props
    const {
      eventData: nextEventData,
      eventFilledData: nextEventFilledData,
    } = nextProps

    if (nextEventFilledData !== eventFilledData) {
      this.setState(this.fetchForm(nextProps, nextEventFilledData.toJS()))

      return false
    }

    if (nextEventData !== eventData) {
      this.setState(this.fetchForm(nextProps))

      return false
    }

    return true
  }

  fetchForm = (
    { activeSite, activeDate, eventData, event: { values = [] } },
    { start_time, end_time, comment, file, result } = {},
  ) => {
    const eventType = eventData.get('type')
    const parameters = eventData.get('parameters')
    const options = eventData.get('options')
    const constantValue = eventData.get('constant_value')
    let currentResult = result || null
    const needs_batch_input = eventData.get('needs_batch_input')
    const batchInputs = {}

    if (needs_batch_input) {
      const filledInputs = values.filter(item => item.evt_logbook_id)

      filledInputs.forEach(({ locus, locus_group, result: batchResult }) => {
        batchInputs[`result-${locus ? locus.id : locus_group.id}`] = batchResult
      })
    }

    switch (eventType) {
      case TYPE_CONSTANT_VALUE:
        currentResult = result ? constantValue : parameters.constant_value
        break
      case TYPE_LIST:
        currentResult = result || Object.keys(options)[0]
        break
      default:
    }

    return {
      ...batchInputs,
      site: activeSite,
      event_date: activeDate,
      start_time: start_time || moment(),
      end_time: end_time || moment(),
      comment: comment || '',
      file: file || getFileObject(),
      result: currentResult,
    }
  }

  fetchEventData = (
    { event, activeSite, fetchSingleEventData, fetchSingleFilledEventData },
    eventId,
  ) => {
    if (eventId) {
      fetchSingleFilledEventData({
        event: eventId,
      })
    } else {
      fetchSingleEventData({
        event: event.id,
        site: activeSite,
        type: LOGBOOK_DAILY,
      })
    }
  }

  onCageChange = e => {
    const { value } = e.target
    const { index } = e.nativeEvent.target.dataset
    const { evt_logbook_id } = this.props.event.values[+index]

    this.setState(
      {
        cage: value,
        valueIndex: +index,
        eventId: evt_logbook_id,
      },
      () => {
        this.fetchEventData(this.props, this.state.eventId)
      },
    )
  }

  onSelectChange = ({ target: { value } }, locusId) => {
    const { eventData } = this.props
    const { needs_batch_input } = eventData.toJS()

    if (needs_batch_input) {
      this.setState({ [`result-${locusId}`]: value })
    } else {
      this.setState({ result: value })
    }
  }

  onCommentChange = e => this.setState({ comment: e.target.value })

  onEventStartTimeChange = time => {
    if (time) {
      this.setState({ start_time: moment(time) })
    }
  }

  onEventEndTimeChange = time => {
    if (time) {
      this.setState({ end_time: moment(time) })
    }
  }

  showFileLoader = isFileLoading => this.setState({ isFileLoading })

  onChangeFile = e => {
    const {
      showNotice,
      uploadFiles,
      intl: { formatMessage },
    } = this.props
    const [file] = e.currentTarget.files

    if (!file) {
      return false
    }

    const fileForm = new FormData()
    fileForm.append('file', file)

    withPromise(uploadFiles, {
      file: fileForm,
      showFileLoader: this.showFileLoader,
      formatMessage,
    }).then(response => {
      if (response.error) {
        showNotice({
          notice: NoticeHelper.createErrorObj(
            formatMessage(messages.fileNotUploadMessage),
          ),
        })
      } else {
        this.setState({
          file: response,
        })
      }
    })
  }

  onRemoveFile = () => {
    const { file } = this.state

    withPromise(this.props.removeFiles, {
      id: file.id,
      showFileLoader: this.showFileLoader,
    }).then(({ error }) => {
      if (!error) {
        this.setState({
          file: getFileObject(),
        })
      }
    })
  }

  getAttachIcon = () => {
    const { isFileLoading } = this.state

    return (
      <span className="attach-icon">
        {isFileLoading ? (
          <CircularProgress color="secondary" size={24} />
        ) : (
          <FileIcon />
        )}
      </span>
    )
  }

  onSubmit = values => {
    const {
      activeSite,
      activeDate,
      eventData,
      saveDailyEntry,
      saveBatchInputs,
      fetchEventList,
      setSingleEventLoader,
      intl: { formatMessage },
    } = this.props
    const {
      id,
      type,
      needs_event_date,
      needs_start_time,
      needs_end_time,
      needs_comment,
      needs_file,
      parameters,
      needs_batch_input,
      needs_locus,
    } = eventData.toJS()
    const {
      eventId,
      cage: locus,
      result,
      start_time,
      end_time,
      comment,
      file,
      site,
      event_date,
    } = values
    const form = { locus }

    const locusKey = needs_locus ? 'locus' : 'locus_group'

    if (needs_batch_input) {
      const regex = /result-/
      const submitData = []

      Object.entries(values).forEach(([key, value]) => {
        if (regex.test(key)) {
          const splitKey = key.split('-')[1]

          submitData.push({
            [locusKey]: splitKey,
            result: value,
          })
        }
      })

      setSingleEventLoader(true)

      return withPromise(saveBatchInputs, {
        params: {
          type: LOGBOOK_DAILY,
          event: eventId,
        },
        message: eventId
          ? formatMessage(messages.changedEntry)
          : formatMessage(messages.savedEntry),
        data: {
          results: submitData,
          site,
          event: id,
          event_date: event_date.format('YYYY-MM-DD'),
        },
      }).then(({ id, errors }) => {
        const nextState = { comment, file, result }

        if (errors) {
          setSingleEventLoader(false)

          return Promise.resolve(errors)
        }

        if (!eventId) {
          nextState.eventId = id
        }

        this.setState(nextState)

        withPromise(fetchEventList, {
          type: LOGBOOK_DAILY,
          site: activeSite,
          date: activeDate.format('YYYY-MM-DD'),
        }).then(() => setSingleEventLoader(false))
      })
    }

    if (!eventId) {
      form.event = id
      form.site = activeSite
    }

    switch (type) {
      case TYPE_INPUT_TEXTAREA:
        form.comment = comment
        break
      case TYPE_INPUT_FILE:
        form.file = result
        break
      case TYPE_CONSTANT_VALUE:
        form.result = parameters.constant_value
        break
      case TYPE_INPUT_NUMBER:
        form.result = parseFloat(result)

        if (Number.isNaN(form.result)) {
          form.result = 0
        }

        break
      default:
        form.result = result
    }

    if (needs_event_date && !eventId)
      form.event_date = activeDate.format('YYYY-MM-DD')

    if (needs_start_time)
      form.start_time = moment.isMoment(start_time)
        ? start_time.format('HH:mm:ss')
        : start_time

    if (needs_end_time)
      form.end_time = moment.isMoment(end_time)
        ? end_time.format('HH:mm:ss')
        : end_time

    if (needs_comment) form.comment = comment

    if (needs_file) form.file = file.id

    setSingleEventLoader(true)

    return withPromise(saveDailyEntry, {
      params: {
        type: LOGBOOK_DAILY,
        event: eventId,
      },
      message: eventId
        ? formatMessage(messages.changedEntry)
        : formatMessage(messages.savedEntry),
      data: form,
    }).then(({ id, errors }) => {
      const nextState = { comment, file, result }

      if (errors) {
        setSingleEventLoader(false)

        return Promise.resolve(errors)
      }

      if (!eventId) {
        nextState.eventId = id
      }

      this.setState(nextState)

      withPromise(fetchEventList, {
        type: LOGBOOK_DAILY,
        site: activeSite,
        date: activeDate.format('YYYY-MM-DD'),
      }).then(() => setSingleEventLoader(false))
    })
  }

  render() {
    const {
      eventData,
      event: { values: eventLocusValues },
      intl: { formatMessage },
    } = this.props
    const {
      id,
      type,
      needs_batch_input,
      needs_start_time,
      needs_end_time,
      needs_comment,
      needs_file,
      parameters: { unit: unitLabel },
      file_title,
      comment_title,
      options,
    } = eventData.toJS()
    const { file } = this.state
    const isSubmitButtonDisabled = type === TYPE_INPUT_FILE && !file.id

    if (!id) {
      return null
    }

    return (
      <Form
        onSubmit={this.onSubmit}
        initialValues={this.state}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={1}>
              {needs_batch_input ? (
                <Table aria-label="simple table" className="batch-table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" size="small">
                        {formatMessage(messages.status)}
                      </TableCell>
                      <TableCell align="center" size="small">
                        {formatMessage(messages.unitItem)}
                      </TableCell>
                      <TableCell size="small">
                        {formatMessage(messages.result)}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {eventLocusValues.map(
                      ({ evt_logbook_id, locus, locus_group }) => (
                        <TableRow key={locus ? locus.name : locus_group.name}>
                          <TableCell align="center" size="small">
                            <StatusIcon
                              small
                              type={
                                evt_logbook_id
                                  ? STATUS_TYPE_COMPLETE
                                  : STATUS_TYPE_BASE
                              }
                            />
                          </TableCell>
                          <TableCell align="center" size="small">
                            {locus ? locus.name : locus_group.name}
                          </TableCell>
                          <TableCell size="small">
                            <Field
                              name={`result-${
                                locus ? locus.id : locus_group.id
                              }`}
                              component={SelectInput}
                              className="result-control"
                              onChange={e => {
                                this.onSelectChange(
                                  e,
                                  locus ? locus.id : locus_group.id,
                                )
                              }}>
                              {Object.keys(options).map(item => (
                                <MenuItem
                                  button
                                  key={item}
                                  value={
                                    !Number.isNaN(item) &&
                                    Number.isInteger(parseFloat(item))
                                      ? options[item]
                                      : item
                                  }>
                                  {options[item]}
                                </MenuItem>
                              ))}
                            </Field>
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                  </TableBody>
                </Table>
              ) : (
                <>
                  <Grid item lg={3} md={4} sm={6} xs={12}>
                    <Field
                      name="cage"
                      component={SelectInput}
                      label={formatMessage(messages.selectLocus)}
                      onChange={this.onCageChange}
                      disabled={submitting}
                      formControlProps={{
                        fullWidth: true,
                        required: true,
                      }}>
                      {eventLocusValues.map(
                        ({ evt_logbook_id, locus }, index) => (
                          <MenuItem
                            button
                            key={locus.id}
                            value={locus.id}
                            data-index={index}>
                            <StatusIcon
                              small
                              type={
                                evt_logbook_id
                                  ? STATUS_TYPE_COMPLETE
                                  : STATUS_TYPE_BASE
                              }
                            />
                            {locus.name}
                          </MenuItem>
                        ),
                      )}
                    </Field>
                  </Grid>
                  {type === TYPE_LIST && (
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <Field
                        name="result"
                        component={SelectInput}
                        className="result-control"
                        label={formatMessage(messages.result)}
                        formControlProps={{
                          required: true,
                        }}
                        onChange={this.onSelectChange}
                        validate={getValidator(VALIDATOR_IS_EMPTY)}>
                        {Object.keys(options).map(item => (
                          <MenuItem
                            button
                            key={item}
                            value={
                              !Number.isNaN(item) &&
                              Number.isInteger(parseFloat(item))
                                ? options[item]
                                : item
                            }>
                            {options[item]}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                  )}
                  {type === TYPE_CONSTANT_VALUE && (
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <Field
                        disabled
                        name="result"
                        type="text"
                        label={formatMessage(messages.result)}
                        component={Input}
                        className="form-control"
                      />
                    </Grid>
                  )}
                  {type === TYPE_INPUT_NUMBER && (
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <Field
                        name="result"
                        type="text"
                        label={formatMessage(messages.result)}
                        component={Input}
                        className="form-control"
                        validate={getValidator([
                          VALIDATOR_IS_NUMBER_OR_FLOAT,
                          VALIDATOR_IS_EMPTY,
                        ])}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {unitLabel}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  )}
                  {needs_start_time && (
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <Field
                        name="start_time"
                        type="text"
                        label={formatMessage(
                          needs_start_time && needs_end_time
                            ? messages.startTime
                            : messages.time,
                        )}
                        component={TimePickerInput}
                        disabled={submitting}
                        onChange={this.onEventStartTimeChange}
                      />
                    </Grid>
                  )}
                  {needs_end_time && (
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <Field
                        name="end_time"
                        type="text"
                        label={formatMessage(messages.endTime)}
                        component={TimePickerInput}
                        disabled={submitting}
                        onChange={this.onEventEndTimeChange}
                      />
                    </Grid>
                  )}
                  {(needs_comment || type === TYPE_INPUT_TEXTAREA) && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <FormControl fullWidth>
                        <FormControlLabel
                          labelPlacement="top"
                          className="form-control-label"
                          label={
                            comment_title &&
                            formatMessage({ id: comment_title })
                          }
                          control={
                            <Field
                              multiline
                              name="comment"
                              component={TextArea}
                              validate={
                                type === TYPE_INPUT_TEXTAREA
                                  ? getValidator(VALIDATOR_IS_EMPTY)
                                  : null
                              }
                              inputProps={{
                                placeholder: formatMessage(messages.addComment),
                                onChange: this.onCommentChange,
                                variant: 'outlined',
                                rows: 3,
                              }}
                            />
                          }
                        />
                      </FormControl>
                    </Grid>
                  )}
                  {(needs_file || type === TYPE_INPUT_FILE) && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <FormControl className="event-file-control">
                        <FormControlLabel
                          labelPlacement="top"
                          className="form-control-label"
                          label={
                            file_title && formatMessage({ id: file_title })
                          }
                          control={
                            <div className="form-group">
                              <div className="event-file-change">
                                {Boolean(file.id) && (
                                  <div className="event-file-uploaded">
                                    <a
                                      href={file.uri}
                                      className="file-link"
                                      target="_blank"
                                      rel="noopener noreferrer">
                                      <Icon>attach_file</Icon>
                                      <span
                                        className="file-name"
                                        title={file.originalName}>
                                        {file.originalName}
                                      </span>
                                    </a>
                                    <IconButton
                                      onClick={this.onRemoveFile}
                                      size="small">
                                      <Icon>clear</Icon>
                                    </IconButton>
                                  </div>
                                )}
                                {!file.id && (
                                  <label className="upload-area">
                                    {this.getAttachIcon()}
                                    {formatMessage(messages.uploadPdfPngJpg)}
                                    <input
                                      type="file"
                                      hidden
                                      onChange={this.onChangeFile}
                                    />
                                  </label>
                                )}
                              </div>
                            </div>
                          }
                        />
                      </FormControl>
                    </Grid>
                  )}
                  {type === TYPE_MULTIPLE && (
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <div className="form-group">
                        <Field
                          name="result"
                          format={value => (Array.isArray(value) ? value : [])}
                          component={FinalFormMultipleSelect}
                          disabled={submitting}
                          data={Object.keys(options)}
                          label={formatMessage(messages.result)}
                          validate={getValidator(VALIDATOR_IS_EMPTY)}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </div>
                    </Grid>
                  )}
                  {type === TYPE_INPUT_BOOLEAN && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className="form-group checkbox-control">
                        <FormControlLabel
                          label={formatMessage(messages.result)}
                          disabled={submitting}
                          control={
                            <Field
                              name="result"
                              type="checkbox"
                              color="primary"
                              component={Checkbox}
                            />
                          }
                        />
                      </div>
                    </Grid>
                  )}
                </>
              )}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Button
                  href={null}
                  type="submit"
                  color="primary"
                  size="medium"
                  variant="contained"
                  onClick={handleSubmit}
                  className="submit-button"
                  disabled={isSubmitButtonDisabled}>
                  {formatMessage(messages.save)}
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      />
    )
  }
}

export default connect(
  state => ({
    eventData: state.getIn(['logbook', 'singleEventData']),
    eventFilledData: state.getIn(['logbook', 'singleFilledEventData']),
  }),
  {
    fetchSingleFilledEventData,
    fetchSingleEventData,
    fetchEventList,
    saveDailyEntry,
    saveBatchInputs,
    showNotice,
    uploadFiles,
    removeFiles,
    setSingleEventLoader,
  },
)(injectIntl(MultiLocusQuestionForm))
